// extracted by mini-css-extract-plugin
export default {"buttonIcon":"CreateGroupModal_buttonIcon__ecKDF","modal":"CreateGroupModal_modal__PUlJR"};